module.exports = __webpack_public_path__ + "img/icn4.1aca5967.svg";